import { zipSync } from 'fflate'

type ZipEntry = [Uint8Array, { level: 0 }]

/**
 * Creates a ZIP archive from image blobs using STORE mode
 * (compression level 0) since JPEG/PNG are already compressed.
 */
export function createZip(
  files: { name: string; data: Uint8Array }[],
): Uint8Array {
  const entries: Record<string, ZipEntry> = {}
  for (const file of files) {
    entries[file.name] = [file.data, { level: 0 }]
  }
  return zipSync(entries)
}

/**
 * Converts a Blob to a Uint8Array for ZIP packaging.
 */
export async function blobToUint8Array(blob: Blob): Promise<Uint8Array> {
  const arrayBuffer = await blob.arrayBuffer()
  return new Uint8Array(arrayBuffer)
}
